export const LAYER365_HOST_SURFACE = Object.freeze({
  LEGACY: 'legacy',
  PRIMARY: 'primary',
});

export const LAYER365_PRIMARY_ORIGIN = 'https://layer365.app';
export const LAYER365_LEGACY_HOSTNAME = 'old.layer365.app';

function normalizeHostname(hostname = '') {
  return String(hostname || '').trim().toLowerCase().replace(/\.$/, '');
}

export function classifyLayer365Hostname(hostname = '') {
  return normalizeHostname(hostname) === LAYER365_LEGACY_HOSTNAME
    ? LAYER365_HOST_SURFACE.LEGACY
    : LAYER365_HOST_SURFACE.PRIMARY;
}

export function isLayer365LegacyHostname(hostname = '') {
  return classifyLayer365Hostname(hostname) === LAYER365_HOST_SURFACE.LEGACY;
}

export function isLegacyRouteRedirectRequired(hash = '') {
  const normalized = String(hash || '').trim();
  return normalized === '#onboarding'
    || normalized === '#home'
    || normalized === '#profile'
    || normalized.startsWith('#center-')
    || normalized.startsWith('#center/')
    || normalized.startsWith('#inquiry/')
    || normalized.startsWith('#pt-')
    || normalized.startsWith('#pt-room/')
    || normalized.startsWith('#assignment-change/')
    || normalized.startsWith('#conversations');
}

export function buildPrimaryLayer365Url(hash = '#auth', locationLike = null) {
  const source = locationLike || (typeof window === 'undefined' ? null : window.location);
  const pathname = source && source.pathname && source.pathname !== '/' ? source.pathname : '/';
  const search = (source && source.search) || '';
  const normalizedHash = String(hash || '').startsWith('#') ? String(hash) : '#auth';
  return `${LAYER365_PRIMARY_ORIGIN}${pathname}${search}${normalizedHash}`;
}

export function isLegacyTrainerAccount(account) {
  return !!account
    && account.needsPersona === false
    && account.needsProfile === false
    && account.primaryPersona === 'trainer';
}
